import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import auth from './auth';
import events from './events';
import profile from './profile';
import common from './common';

export default history =>
  combineReducers({
    router: connectRouter(history),
    auth: auth,
    events: events,
    profile: profile,
    common: common
  });
